export const addUserMessage = ({ sender, text, time, isNewMessage }) =>
	({
		type: 'ADD_NEW_MESSAGE',
		payload: { sender, text, time, isNewMessage }
	});

export const addChatHistory = (chatHistory) =>
	({
		type: 'ADD_CHAT_HISTORY',
		payload: { chatHistory }
	});

export const setReadMessage = () =>
	({
		type: 'SET_READ_MESSAGE'
	});

export const clearChat = () =>
	({
		type: 'CLEAR_CHAT'
	});